import React, { useEffect, useState } from "react";
import DynamicTable from "../../../Components/InputComponents/LookupView";
import { Edit, Delete, Visibility } from "@mui/icons-material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { axiosAPI } from "../../../Components/AxiosComponents/Axios";
import { encryptId } from "../../../Components/CryptoComponent";

function CompanyTypeList() {
  const navigate = useNavigate();
  const columns = [
    { field: "CT_Id", label: "#" },
    { field: "CT_Name", label: "Company Type" },
    { field: "CT_Status", label: "Status" },
  ];

  const [searchParams] = useSearchParams();


  const actions = [
    {
      icon: Edit,
      handler: (row) => {
        const encrypted = encodeURIComponent(encryptId(row?.CT_Id));

        navigate(
          `/CompanyTypeLookup/Edit/${encrypted}?${searchParams.toString()}`
        );
      },
      color: "warning",
    },
  ];
  return (
    <DynamicTable
      columns={columns}
      dataAPI={`/CompanyType/list`}
      actions={actions}
      title={`Company Type`}
      linkvalue={`/CompanyTypeLookup/Add?${searchParams.toString()}`}
    />
  );
}

export default CompanyTypeList;
